import {GameUIToolTips} from '../../GameUIToolTips'
import {PIXI} from '@colonist/pixi'
import {SpriteButtonView} from '../../ui_canvas_engine/SpriteButtonView'
import {SectionView} from '../../ui_canvas_engine/SectionView'
import {uiGameManager} from '../../../../shared/scripts/EntryShared'
import {UIUtilsEjsVariables} from '../../UIUtilsEjsVariables'
import {UIGameSpriteHandler} from '../../UIGameSpriteHandler'
import {Sprites} from '../UIGameImageDictionary'

export class UIGamePopupConfirmationButtons extends SectionView {
    readonly checkButton: SpriteButtonView
    readonly cancelButton: SpriteButtonView

    constructor(x: number, y: number, w: number, h: number, checkAction: () => void, cancelAction: () => void, container: PIXI.Container, showCancelButton: boolean = true) {
        super(x, y, w, h, container)

        this.bg.eventMode = 'none'

        const canvas = uiGameManager.canvasController

        const isUsingNewMobileUI = (UIUtilsEjsVariables.isUserOnMobileApp && UIUtilsEjsVariables.shouldDisplayNewMobileGameUI)
        const margin = isUsingNewMobileUI ? canvas.itemSize / 6 : canvas.margin * 2

        const buttonH = h - margin
        const containerW = w
        const checkButtonX = containerW - buttonH - margin
        const cancelButtonX = checkButtonX - buttonH

        this.checkButton = new SpriteButtonView(checkButtonX, 0, buttonH, buttonH, this)
        this.checkButton.addCenteredIcon(UIGameSpriteHandler.getTextureFromSpritesheet(Sprites.icon_check))
        this.checkButton.updateAction(() => {
            checkAction()
            GameUIToolTips.remove(this.checkButton)
        })
        this.checkButton.inactivateOpacity()

        this.cancelButton = new SpriteButtonView(cancelButtonX, 0, buttonH, buttonH, this)
        this.cancelButton.addCenteredIcon(UIGameSpriteHandler.getTextureFromSpritesheet(Sprites.icon_x))
        this.cancelButton.updateAction(() => {
            cancelAction()
            GameUIToolTips.remove(this.cancelButton)
        })
        if(!showCancelButton) this.hideCancelButton()
    }

    hideCancelButton() {
        if(this.cancelButton.parent == undefined) return
        this.cancelButton.parent.removeChild(this.cancelButton)
    }

    showCancelButton() {
        if(this.cancelButton.parent != undefined) return
        this.addChild(this.cancelButton)
    }
}
